<template>
  <div>
    <BaseTopLine> </BaseTopLine>
    <div>
      <div
        class="tw-bg-main2 tw-py-[10px] tw-px-[20px] tw-rounded-[6px] tw-mx-[26px] tw-text-[12px] tw-text-white"
      >
        <div class="tw-flex tw-justify-between">
          <div class="tw-flex tw-items-end tw-gap-[20px]">
            <div class="tw-app-input-container">
              <label class="tw-app-input-container-label">{{
                dataLang["register_academy_text_13"]
              }}</label>
              <BaseInputNew
                @keyupEnter="loadData()"
                inputClass="tw-app-input-dark"
                @input="(data) => (searchString = data.value)"
                inputName="searchString"
                :value="searchString"
              />
            </div>
            <div class="tw-flex tw-flex-row">
              <button
                type="button"
                class="tw-app-btn-primary"
                @click="loadData()"
              >
                {{ dataLang["register_academy_text_14"] }}
              </button>
              <button
                type="button"
                class="tw-app-btn-light"
                @click="
                  () => {
                    searchString = '';
                    loadData();
                  }
                "
              >
                {{ dataLang["register_academy_text_15"] }}
              </button>
            </div>
          </div>

          <div class="tw-flex tw-gap-[20px] tw-items-center">
            <CheckCertificate />
            <div
              class="tw-underline tw-cursor-pointer"
              @click="$modal.show('supportModal')"
            >
              {{ dataLang["register_academy_text_16"] }}
            </div>
          </div>
        </div>
      </div>
      <div class="tw-px-[26px]">
        <div class="tw-flex tw-justify-end tw-my-[15px]">
          <TwBasePagination
            :page-count="numPages"
            :pagination-params="{
              ...paginationFinesStateParams,
              limit: limitPaginationValue,
            }"
            :showLimitInput="true"
            @updateLimitValue="updateLimitValue"
            :page-range="10"
            :margin-pages="0"
            :click-handler="loadData"
          >
          </TwBasePagination>
        </div>
        <div class="tw-relative" style="min-height: 400px">
          <BaseLoader v-if="localLoading" style="z-index: 50"></BaseLoader>
          <ve-table
            class="fixed-header rest-style-table"
            style="width: 100%; z-index: 1"
            :columns="columns"
            :table-data="dataTable"
            :border-x="true"
            :border-y="true"
            row-key-field-name="academy__id"
            ref="mainTable"
            :eventCustomOption="eventCustomOption"
            :cell-style-option="cellStyleOption"
            :checkbox-option="{
              selectedRowChange: selectedRowChange,
              selectedAllChange: selectedAllChange,
              hideSelectAll: false,
            }"
            :clickHighlight="false"
            :rowStyleOption="{
              hoverHighlight: true,
            }"
            :cellSelectionOption="{ enable: false }"
          >
          </ve-table>
        </div>
      </div>
    </div>

    <BaseModal
      name="supportModal"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="320"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <BaseLoader
          v-if="localLoading"
          class="tw-rounded-[25px]"
          style="z-index: 100"
        ></BaseLoader>
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('supportModal')"
        ></button>
        <div class="tw-text-center">
          <div class="tw-app-modal__title">
            Запрос на создание новой инструкции
          </div>

          <div v-html="dataLang['register_academy_text_17']"></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('supportModal')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["register_academy_text_18"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import GeneralService from "@/api/GeneralService";
import httpInstance from "@/http-common";
import { VueTabs, VTab } from "vue-nav-tabs/dist/vue-tabs.js";
import EventBus from "@/event-bus";
import CheckCertificate from "@/components/CheckCertificate.vue";

export default {
  components: {
    VeTable,
    VueTabs,
    VTab,
    CheckCertificate,
  },

  data() {
    return {
      limitPaginationValue: 50,
      localLoading: true,
      dataTable: [],
      activeSelectRowsMultiple: [],
      filter: [],
      updatedValues: {},
      activePagePagination: {},
      selectsData: {},
      countriesList: [],
      searchString: "",
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {},
          };
        },
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {},
      },
    };
  },
  methods: {
    updateLimitValue(data) {
      this.limitPaginationValue = data;
      this.loadData();
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    selectedAllChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },

    updateValue(data) {
      this.updatedValues[data.name] = data.value;
    },

    computedTranslate(values, tranaslate) {
      let keys = Object.keys(values);
      let tranaslateLocal = tranaslate;
      keys.forEach((keyName) => {
        tranaslateLocal = tranaslateLocal.replace(
          `\\${keyName}\\`,
          values[keyName]
        );
      });
      return tranaslateLocal;
    },

    handleTabChange(tabIndex, newTab, oldTab) {},

    resetFilter() {
      this.$refs.mainTable.$el
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });
      this.filter = [];
      this.loadData();
    },

    loadData(page = 1) {
      this.localLoading = true;
      Promise.all([]).then(() => {
        GeneralService.get(`/academy/table/main`, {
          params: {
            ...(this.searchString && { search: this.searchString }),
            limit: this.limitPaginationValue,
            page: page,
          },
        })
          .then((data) => {
            this.dataTable = data.data.data.rows;
            this.getFinesAll(data.data.data);
            this.localLoading = false;
          })
          .catch((e) => {
            this.$toast.error("Неизвестная ошибка при загрузке таблицы", {
              duration: 5000,
            });
          });
      });
    },
    fillFilter(data) {
      console.log(data);
      let newValueFilter =
        data.type == "like" ? `;percent;${data.value};percent;` : data.value;
      if (!this.filter.find((x) => x.field == data.name)) {
        this.filter.push({
          field: data.name,
          value: newValueFilter,
          ...(data.type == "like" && { operator: "like" }),
          ...(data.operator && { operator: data.operator }),
          ...(data.mod && { mod: data.mod }),
        });
      } else {
        let indexed = this.filter.findIndex((x) => x.field == data.name);
        this.filter[indexed].value = newValueFilter;
        if (data?.operator) {
          this.filter[indexed].operator = data.operator;
        }
      }
      let indexed = this.filter.findIndex((x) => x.field == data.name);
      if (indexed !== -1) {
        this.filter[indexed].value = newValueFilter;
        if (data.type == "delete") {
          console.log(323323223);
          this.filter.splice(indexed, 1);
        }
      }
    },
    onOpenModalReview() {},

    async onLoadFile(e) {
      this.localLoading = true;
      let file = e.target.files[0];
      let formData = new FormData();
      formData.append("file", file);
      formData.append("type", "default");
      try {
        let dataFrom = await GeneralService.editOrCreate("/storage", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        this.fileUrl = dataFrom.data.data.url;
        this.fileId = dataFrom.data.data.id;
        this.dataForModal.academy__file_id = dataFrom.data.data.id;

        this.updateValue({
          name: "academy__file_id",
          value: dataFrom.data.data.id,
        });
        this.localLoading = false;
      } catch (error) {
        this.$toast.error(error, { duration: 5000 });
        this.$modal.hide("addNote");
      }
    },

    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element["label"] = element[Object.keys(element).pop()];
          element["key"] = key;
          element["value"] = Object.keys(element)[0];
          element["selectName"] = keyDataFromFetch;
        });
      }
      return data;
    },

    ...mapActions("finesPagination", ["getFinesAll"]),
  },
  mounted() {
    EventBus.$on("updateContentData", () => {
      this.loadData();
    });
  },
  created() {
    this.loadData();
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
    ...mapState("finesPagination", ["paginationFinesStateParams"]),
    ...mapGetters("finesPagination", ["numPages"]),

    columns() {
      return [
        {
          field: "academy__id",
          key: "1623236",
          title: this.dataLang["register_academy_text_3"],
          align: "center",
          width: "5%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "academy__subject",
          key: "162336",
          title: this.dataLang["register_academy_text_4"],
          align: "left",
          width: "45%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "academy__video_link",
          key: "12861326",
          title: this.dataLang["register_academy_text_5"],
          align: "center",
          width: "10%",

          ellipsis: {
            lineClamp: false,
            showTitle: false,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span
                style={"-webkit-line-clamp: none !important; display: block;"}
              >
                {row.academy__video_link ? (
                  <div
                    style={
                      "text-decoration: underline; cursor: pointer; -webkit-line-clamp: none;"
                    }
                    onClick={() => {
                      this.$modal.show("modalVideoSupport", {
                        videoID: row.academy__video_link,
                      });
                    }}
                  >
                    Смотреть
                  </div>
                ) : (
                  ""
                )}
              </span>
            );
          },
        },
        {
          field: "storage_s3__s3_uri",
          key: "16336",
          title: this.dataLang["register_academy_text_6"],
          align: "center",
          width: "10%",

          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },

          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.storage_s3__s3_uri ? (
                  <a
                    href={row.storage_s3__s3_uri}
                    target="_blank"
                    style={"text-decoration: underline; cursor: pointer"}
                  >
                    Скачать
                  </a>
                ) : (
                  ""
                )}
              </span>
            );
          },
        },
      ];
    },
  },
};
</script>
